import { render, staticRenderFns } from "./employee-single.vue?vue&type=template&id=e8e54b9c&scoped=true&"
import script from "./employee-single.vue?vue&type=script&lang=js&"
export * from "./employee-single.vue?vue&type=script&lang=js&"
import style0 from "./employee-single.vue?vue&type=style&index=0&id=e8e54b9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e54b9c",
  null
  
)

export default component.exports